import axios from "axios";
import getBackendURL from "./api/api";

export interface User {
  	email: string;
	first_name: string;
	last_name: string;
	groups: string[]; // group name
	group_ids: string[];
	access_token: string;
	admin: boolean;
	enable: boolean;

	group_names: string[];
	refresh_token: string;
}

const localStorageKey = "user";

export function getCurrentUser(): User | null {
	let currentUser: User | null = null;
	try {
		currentUser = JSON.parse(localStorage.getItem(localStorageKey)!);
	} catch {}
	return currentUser;
}

export function setCurrentUser(user: User | null) {
	if (!user) {
		localStorage.removeItem(localStorageKey);
	} else {
		localStorage.setItem(localStorageKey, JSON.stringify(user));
	}
}

export function logout() {
  setCurrentUser(null);
  // Also end the Keycloak SSO session — otherwise it stays alive and the
  // next /login auto-redirect silently re-authenticates against it.
  window.location.href =
    process.env.REACT_APP_KEYCLOAK_URL +
    `/realms/clowder/protocol/openid-connect/logout?post_logout_redirect_uri=${process.env.REACT_APP_KEYCLOAK_REDIRECT_URI}&client_id=${process.env.REACT_APP_KEYCLOAK_CLIENT_ID}`;
}

export function getAccessToken(): string {
  const user = getCurrentUser();
  return user ? user.access_token : "";
}

export async function exchangeOidcCode(code: string): Promise<User> {
  const { data } = await axios.post<User>(getBackendURL("/clowder/auth_callback"), { code });
  return data;
}
